import { Report } from './report';

export class CReport extends Report {
    constructor(
            public carId: number = null,
            public aDt: Date = new Date(),
            public getFile: number = 0) { super(); }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/report/c.report.ts